import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IIconNav } from './icon.nav.interface';
import { IFaIcon } from './../../atoms/fa.icon/fa.icon.interface';
import { fadeAnimation } from './../../../shared/animations/fade.animation';

@Component({
    selector: 'mlp-ng-icon-nav',
    templateUrl: './icon.nav.component.html',
    styleUrls: ['./icon.nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [fadeAnimation]
})

export class IconNavSharedComponent {
    hidden = true;
    openIcon: IFaIcon = { name: 'ellipsis-h', size: 'fa-2x' };
    closeIcon: IFaIcon = { name: 'times', size: 'fa-lg' };

    @Input() links: Array<IIconNav>;

    toggleNav(status?: boolean): void {
        this.hidden = (status) ? status : !this.hidden;
    }
}
